import React, { useState, useEffect } from "react";
import { Modal, Button } from "react-bootstrap";
import { FaStar } from "react-icons/fa";
import { useSelector, useDispatch } from "react-redux";
import {
  getBookCustomerDetailAction,
  addReviewAction,
  getReviewListAction,
} from "../../redux/booking/BookingSlice";
import { Snackbar, Alert } from "@mui/material";
import { useTranslation } from "react-i18next";

const ReviewModal = ({ show, onClose, id_booking }) => {
  const [rating, setRating] = useState(0);
  const [hover, setHover] = useState(null);
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(true);
  const [showConfirm, setShowConfirm] = useState(false);
  const [customerDetailId, setCustomerDetailId] = useState(null);
  const [hasExistingReview, setHasExistingReview] = useState(false);
  const { t } = useTranslation();

  const idUserTMY = useSelector((state) => state.AuthSlice.user?.idUserTMY);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });
  const showSnackbar = (message, severity = "success") => {
    setSnackbar({ open: true, message, severity });
  };

  const dispatch = useDispatch();
  const todos = useSelector((state) => state);
  const customerDetails = todos.Booking.bookCustomerDetailList.data || [];
  const reviews = todos.Booking.reviewList?.data || [];

  useEffect(() => {
    const fetchData = async () => {
      try {
        await dispatch(getBookCustomerDetailAction({}));
        dispatch(getReviewListAction({}));
        setLoading(false);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, [dispatch]);

  useEffect(() => {
    const intervalId = setInterval(() => {
      dispatch(getReviewListAction({}));
    }, 5000);

    return () => clearInterval(intervalId);
  }, [dispatch]);

  useEffect(() => {
    if (!loading && customerDetails.length > 0) {
      const matched = customerDetails.find(
        (item) => Number(item.id_booking) === Number(id_booking)
      );
      if (matched) {
        setCustomerDetailId(matched.id_bookCustomerdetail);
      }
    }
  }, [loading, customerDetails, id_booking]);

  useEffect(() => {
    const matchedReview = reviews.find(
      (review) => Number(review.id_booking) === Number(id_booking)
    );

    if (matchedReview) {
      setHasExistingReview(true);
      setRating(matchedReview.rating);
      setMessage(matchedReview.comment || "");
    } else {
      setHasExistingReview(false);
      // if (!message) setRating(0);
    }
  }, [reviews, id_booking]);

  // useEffect(() => {
  //   // หารีวิวที่ตรงกับ id_booking
  //   const matchedReview = reviews.find(
  //     (review) => Number(review.id_booking) === Number(id_booking)
  //   );

  //   if (matchedReview) {
  //     setHasExistingReview(true);
  //     setRating(matchedReview.rating);
  //     setMessage(matchedReview.comment || "");
  //   } else {
  //     setHasExistingReview(false);
  //     setRating(0);
  //     setMessage("");
  //   }
  // }, [reviews, id_booking]);

  const handleSubmit = async () => {
    if (!rating) {
      showSnackbar(t("Please select a rating."), "warning");
      return;
    }
    if (!customerDetailId) {
      showSnackbar(t("Customer detail not found."), "error");
      return;
    }
    if (!idUserTMY) {
      showSnackbar(t("User not logged in."), "error");
      return;
    }

    const payload = {
      id_booking,
      id_bookCustomerdetail: customerDetailId,
      idUserTMY,
      rating,
      comment: message,
    };

    try {
      await dispatch(addReviewAction(payload));
      showSnackbar(t("Review submitted successfully!"), "success");
      onClose();
    } catch (error) {
      console.error("Error submitting review:", error);
      showSnackbar(t("An error occurred while submitting your review."), "error");
    }
  };

  const handleSubmitReview = () => {
  if (!rating) {
    // แจ้งเตือนให้เลือก Rating
    return;
  }

  if (!message.trim()) {
    // แจ้งเตือนให้กรอก Message
    return;
  }

  setShowConfirm(true);
};

  return (
    <>
      <Modal
        show={show}
        onHide={onClose}
        centered
        backdrop="static"
        size="md"
        dialogClassName="review-modal-dialog"
        contentClassName="review-modal-content"
      >
        <div className="card-white">
          <Modal.Header className="section-divider">
            <Modal.Title className="title-primary">
              {t("Review")}
            </Modal.Title>

            <button
              type="button"
              className="btn-close no-shadow"
              aria-label="Close"
              onClick={onClose}
            ></button>
          </Modal.Header>

          <Modal.Body className="pt-20">
            <div>
              <label className="label-primary">
                {t("Ratings")}
              </label>

              <div className="mb-20">
                {[...Array(5)].map((_, index) => {
                  const currentRating = index + 1;

                  return (
                    <FaStar
                      key={index}
                      size={28}
                      style={{
                        marginRight: 6,
                        cursor: hasExistingReview
                          ? "not-allowed"
                          : "pointer",
                        pointerEvents: hasExistingReview
                          ? "none"
                          : "auto",
                      }}
                      color={
                        currentRating <= (hover || rating)
                          ? "#f5b50a"
                          : "#d7dce3"
                      }
                      onClick={() =>
                        !hasExistingReview &&
                        setRating(currentRating)
                      }
                      onMouseEnter={() =>
                        !hasExistingReview &&
                        setHover(currentRating)
                      }
                      onMouseLeave={() =>
                        !hasExistingReview &&
                        setHover(null)
                      }
                    />
                  );
                })}
              </div>

              <textarea
                placeholder={t("Message")}
                className="form-control textarea-primary"
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                disabled={hasExistingReview}
              />
            </div>
          </Modal.Body>

          <Modal.Footer className="footer-actions">
            {!hasExistingReview && (
              <Button
                onClick={() => setShowConfirm(true)}
                className="btn-primary-pill-dark"
                disabled={!rating}
              >
                {t("Submit")}
              </Button>
            )}
          </Modal.Footer>
        </div>
      </Modal>

      <Modal
        show={showConfirm}
        onHide={() => setShowConfirm(false)}
        centered
        backdrop="static"
        dialogClassName="confirm-review-modal"
        contentClassName="confirm-review-modal-content"
      >
        <Modal.Header className="confirm-review-header" closeButton>
          <Modal.Title className="confirm-review-title">
            {t("Confirm Review")}
          </Modal.Title>
        </Modal.Header>

        <Modal.Body className="confirm-review-body">
          {t("Are you sure you want to submit your review?")}
        </Modal.Body>

        <Modal.Footer className="confirm-review-footer">
          <Button
            variant="secondary"
            onClick={() => setShowConfirm(false)}
            className="confirm-cancel-button"
          >
            {t("Cancel")}
          </Button>

          <Button
            onClick={() => {
              setShowConfirm(false);
              handleSubmit();
            }}
            className="confirm-submit-button"
          >
            {t("Confirm")}
          </Button>
        </Modal.Footer>
      </Modal>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={4000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        sx={{
          width: "auto",
        }}
      >
        <Alert
          sx={{
            borderRadius: 8,
          }}
          elevation={6}
          variant="filled"
          onClose={() => setSnackbar({ ...snackbar, open: false })}
          severity={snackbar.severity}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </>
  );
};

export default ReviewModal;
